(() => {
  if (window.caffreyZephyrBooted) return;
  window.caffreyZephyrBooted = true;
  const controllers = new Map();
  function init(scope = document) {
    const roots = [...scope.querySelectorAll('[data-zephyr-main], [data-z-features]')];
    if (scope.matches?.('[data-zephyr-main], [data-z-features]')) roots.unshift(scope);
    roots.forEach(root => {
      if (controllers.has(root)) return;
      const controller = new AbortController(), signal = controller.signal;
      const submit = root.querySelector('[data-zephyr-submit]');
      if (submit) {
        const variants = [...root.querySelectorAll('[data-zephyr-variant]')];
        const update = (changeURL = false) => {
          const selected = variants.find(input => input.checked);
          const available = selected?.dataset.available === 'true';
          submit.disabled = !available;
          submit.textContent = !selected ? submit.dataset.choose : available ? submit.dataset.add : submit.dataset.sold;
          if (selected) {
            root.querySelectorAll('[data-zephyr-price]').forEach(el => el.textContent = selected.dataset.price);
            if (changeURL) { const url = new URL(location.href); url.searchParams.set('variant', selected.value); history.replaceState({}, '', url); }
          }
        };
        variants.forEach(input => input.addEventListener('change', () => update(true), {signal}));
        update();
        const gallery = root.querySelector('[data-z-gallery]'), slides = [...gallery.querySelectorAll('[data-z-slide]')], dots = [...gallery.querySelectorAll('[data-z-dot]')];
        let current = 0;
        const show = index => {
          current = (index + slides.length) % slides.length;
          slides.forEach((slide,i) => {slide.classList.toggle('is-active', i === current); slide.hidden = i !== current;});
          dots.forEach((dot,i) => dot.setAttribute('aria-current', String(i === current)));
        };
        gallery.dataset.enhanced = 'true';gallery.querySelector('[data-z-gallery-controls]').hidden = false;
        gallery.querySelector('[data-z-prev]').addEventListener('click', () => show(current - 1), {signal});
        gallery.querySelector('[data-z-next]').addEventListener('click', () => show(current + 1), {signal});
        dots.forEach((dot,i) => dot.addEventListener('click', () => show(i), {signal}));
        show(0);
      }
      const buttons = [...root.querySelectorAll('[data-z-feature]')], panels = [...root.querySelectorAll('[data-z-panel]')];
      if (buttons.length) {
        const select = index => {buttons.forEach((button,i) => button.setAttribute('aria-pressed', String(i === index)));panels.forEach((panel,i) => panel.hidden = i !== index);};
        buttons.forEach((button,i) => {
          button.addEventListener('click', () => select(i), {signal});
          button.addEventListener('keydown', e => {
            if (!['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
            e.preventDefault();const n=e.key==='Home'?0:e.key==='End'?buttons.length-1:(i+(e.key==='ArrowRight'?1:-1)+buttons.length)%buttons.length;
            buttons[n].focus();select(n);
          }, {signal});
        });
        root.querySelector('.cf-z-feature-labels').hidden = false;select(0);
      }
      let observer;
      const floating=root.querySelector('[data-zephyr-floating]'),buy=root.querySelector('.cf-z-buy');
      if ('IntersectionObserver' in window && floating && buy) {observer=new IntersectionObserver(([entry])=>{floating.hidden=entry.isIntersecting||entry.boundingClientRect.bottom>0;},{threshold:0});observer.observe(buy);}
      controllers.set(root,{controller,observer});
    });
  }
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:unload',e=>{for (const [root,state] of controllers) if (e.target.contains(root)){state.controller.abort();state.observer?.disconnect();controllers.delete(root);}});
  document.addEventListener('shopify:block:select',e=>{const panel=e.target.closest('[data-z-panel]');if(panel)panel.closest('[data-z-features]').querySelector(`[data-z-feature="${panel.dataset.zPanel}"]`)?.click();const details=e.target.closest('.cf-z-question');if(details)details.open=true;});
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init(),{once:true});else init();
})();
